import { lazy } from 'react';

const MemberEventsRequestModal = lazy(() => import('./RequestModal'));
const MemberVirtualLinkModal = lazy(() => import('./VirtualLinkModal'));
const MemberUserListModal = lazy(() => import('./UserListModal'));
const SendMailModal = lazy(() => import('./SendMailModal'));
const DistrictListModal = lazy(() => import('./DistrictListModal'));
const UpdateEventScopeWarningModal = lazy(
  () => import('./UpdateEventScopeWarningModal'),
);
const DistrictEventsDrawer = lazy(() => import('./DistrictEventsDrawer'));
const HostEventAttendeeDrawer = lazy(() => import('./HostEventAttendeeDrawer'));
const TerritoryDistrictEventsDrawer = lazy(
  () => import('./TerritoryDistrictEventsDrawer'),
);

const SetTerritoryModal = lazy(() => import('./SetTerritoryModal'));

export default {
  MEMBER_EVENTS_REQUEST_MODAL: MemberEventsRequestModal,
  MEMBER_VIRTUAL_LINK_MODAL: MemberVirtualLinkModal,
  MEMBER_USER_LIST_MODAL: MemberUserListModal,
  SEND_EMAIL_MODAL: SendMailModal,
  DISTRICT_LIST_MODAL: DistrictListModal,
  UPDATE_EVENT_SCOPE_WARNING_MODAL: UpdateEventScopeWarningModal,
  DISTRICT_EVENTS_DRAWER: DistrictEventsDrawer,
  HOST_EVENT_ATTENDEE_DRAWER: HostEventAttendeeDrawer,
  TERRITORY_DISTRICT_EVENT_DRAWER: TerritoryDistrictEventsDrawer,
  SET_TERRITORY_MODAL: SetTerritoryModal,
};
